import PropTypes from "prop-types";
import React from "react";
import environment from "web/script/modules/environment";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import { BuyOptionPropType } from "web/types/buy-option";

export function ScriptTag({ jsonLD }) {
    return (
        <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }}
        />
    );
}
ScriptTag.propTypes = {
    jsonLD: PropTypes.object.isRequired,
};

function ProductStructuredData({ product, designer, buyOption, absoluteUrl }) {
    // TODO: When this is used on InStock product pages some fields are missing "isSimilarTo" "isRelatedTo"

    // This should be added to a size object - need to check it is accessible in hypernova ...
    const currency =
        environment.get("currencyProps") && environment.get("currencyProps").currencyCode;
    const selectedSize = buyOption.sizes[buyOption.default_size];
    const jsonLD = {
        "@context": "https://schema.org/",
        "@type": "Product",
        url: absoluteUrl,
        name: product.short_description,
        image: product.images.map((image) => image.full_size_url), // TODO (Before using in prod) Merge - https://git.lystit.com/lyst/lyst/pull/14325
        description: product.long_description,
        sku: product.product_id,
        brand: {
            "@type": "Thing",
            name: designer.name,
        },

        offers: {
            "@type": "Offer",
            url: absoluteUrl,
            priceCurrency: currency, // Get from env ?
            price: selectedSize.sale_price, // Price / sale_price ?
            itemCondition: "https://schema.org/NewCondition",
            availability: buyOption.in_stock
                ? "https://schema.org/InStock"
                : "https://schema.org/OutOfStock",
            seller: {
                "@type": "Organization",
                name: buyOption.retailer_name,
            },
        },
    };

    return <ScriptTag jsonLD={jsonLD} />;
}

ProductStructuredData.propTypes = {
    absoluteUrl: PropTypes.string.isRequired,
    product: ProductPropType.isRequired,
    buyOption: BuyOptionPropType.isRequired,
    designer: DesignerPropType.isRequired,
};
export default ProductStructuredData;
